<template>
  <div style="margin: 0 24px 12px;">
    <el-form ref="formRef" label-width="auto" label-position="right">
      <el-form-item label="商品库存：">
        {{stockForm.currentStockNum}}
      </el-form-item>
<!--      <el-form-item label="类型：">-->
<!--        {{type == -1?'系统出库':'系统入库'}}-->
<!--      </el-form-item>-->
      <el-form-item :label="type == -1?'出库数量：':'入库数量：'">
        <el-input v-model="num" placeholder="请输入数量" />
      </el-form-item>
      <el-form-item label="商品售价：" v-if="type == -1">
        <el-input v-model="price" placeholder="请输入商品售价" />
      </el-form-item>
      <el-form-item label="进货单价：" v-if="type == 1 && stockForm.price">
        {{stockForm.price}}
      </el-form-item>
      <el-form-item label="备注：">
        <el-input type="textarea" :rows="4" v-model="remark" placeholder="请输入备注内容" style="width: 100%; flex: 1"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {addSysShopCommodity} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      type: this.value.type,
      stockForm: this.value.stockForm,

      num: '',
      remark: '',
      price: '',

    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.num) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入数量',
          type: 'warning'
        });
        return false
      }
      if(!this.price && this.type == -1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入商品售价',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.stockForm.shopCommodityId
      param['type'] = this.type
      param['remark'] = this.remark
      param['num'] = this.num
      if(this.type == -1) {
        param['price'] = this.price
      }
      postFormData(addSysShopCommodity, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
